import { ConfigProvider } from 'antd';
import { useCallback, useEffect } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import { useDispatch } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import { getMe, getTokenLocalStorage } from './actions/auth';
import { parseJwt } from './helpers/jwt';
import { AuthActionTypeEnum } from './interfaces/Reducer.interface';
import './styles/variables.css';

const App = (): JSX.Element => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Configure Ant Design theme to use Inter font
  const antdTheme = {
    token: {
      fontFamily:
        "'Inter', -apple-system, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
    },
  };

  const verifyToken = useCallback(async () => {
    try {
      const { accessToken } = getTokenLocalStorage();
      if (!accessToken) {
        dispatch({
          type: AuthActionTypeEnum.SET_AUTHENTICATING,
          payload: {
            authenticating: false,
          },
        });
        navigate('/login');
        return;
      }

      if (!!accessToken) {
        const { sub, role } = parseJwt(accessToken);
        unstable_batchedUpdates(() => {
          dispatch({
            type: AuthActionTypeEnum.LOGIN_SUCCESS,
            payload: {
              authUser: {
                id: sub,
                role,
              },
            },
          });
        });

        // Fetch the full user data
        dispatch(getMe());
      }

      dispatch({
        type: AuthActionTypeEnum.SET_AUTHENTICATING,
        payload: {
          authenticating: false,
        },
      });
    } catch (e) {
      console.error(e);
      dispatch({
        type: AuthActionTypeEnum.SET_AUTHENTICATING,
        payload: {
          authenticating: false,
        },
      });
      dispatch({
        type: AuthActionTypeEnum.LOGOUT_REQUEST,
      });
      navigate('/login');
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  // if (!isAuthenticating) {
  //   return <LoadingSpinner />;
  // }

  return (
    <ConfigProvider theme={antdTheme}>
      <Outlet />
    </ConfigProvider>
  );
};
export default App;
